import { useRef, useEffect } from 'react';
import './SectionNavigation.css';

const SectionNavigation = () => {
  const carsScrollContainerRef = useRef(null);

  // Attach ref to the cars scroll container
  useEffect(() => {
    const carsContainer = document.querySelector('.cars-scroll-container');
    if (carsContainer) {
      carsScrollContainerRef.current = carsContainer;
    }
  }, []);

  // Controls removed per request
  return null;
};

export default SectionNavigation;

